// extracted by mini-css-extract-plugin
export default {"blogsContainer":"Blogs_blogsContainer__5BCBB"};